import { call, put, takeLatest } from 'redux-saga/effects';

import * as twitchActions from './twitchActions.js';
import { updateTwitchApiCall } from './twitchAPI.js';

function* updateTwitchSaga({ payload }) {
  try {
    const { data } = yield call(updateTwitchApiCall, payload);
    yield put(twitchActions.twitchUpdateStore(data));
  } catch (error) {
    yield put(twitchActions.twitchUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* twitchWatcher() {
  yield takeLatest(twitchActions.twitchUpdateRequest.type, updateTwitchSaga);
}
